import React from 'react';

import {useUserNameMapper} from 'src/components/user-name/hooks/useUserNameMapper';
import {getUsersInfo} from 'src/modules/users-info/services';
import {useAppSelector} from 'src/store';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';

type Props = {
    email: string,
    showActive?: boolean,
};

export const UserName = ({email, showActive}: Props) => {
    const usersInfo = useAppSelector(getUsersInfo);
    const {emailToName} = useUserNameMapper();

    if (showActive && usersInfo?.[email]?.active === false) {
        return (
            <Group direction="v" gap="none">
                <Item><EllipsisTextHint>{emailToName[email]}</EllipsisTextHint></Item>
                {emailToName[email] ? <Item>(inactive)</Item> : null}
            </Group>
        );
    }

    return (
        <EllipsisTextHint>{emailToName[email] || email}</EllipsisTextHint>
    );
};
